<template>
  <div class="opening-red-invoice">
    <header>
      <h6>红冲原因</h6>
    </header>
    <main>
      <div class="card">
        <van-field v-model="invoiceInfo.invoiceCode" label="发票代码" placeholder="请输入发票代码" readonly />
        <van-field v-model="invoiceInfo.invoiceNo" label="发票号码" placeholder="请输入发票号码" readonly />
      </div>
      <ModuleHeadText title="蓝票信息" />
      <div class="card">
        <van-field v-model="invoiceInfo.drewDate" label="开票日期" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.purchaserName" label="购方名称" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.amountWithTax" label="价税合计" placeholder="自动带入" readonly />
      </div>
      <ModuleHeadText title="红冲原因" />
      <div class="card">
        <div class="apply-plan">
          <van-radio-group v-model="applicationType" direction="horizontal">
            <van-radio icon-size="18" name="1">销方申请</van-radio>
            <van-radio v-if="!getInvoiceType" icon-size="18" name="2">购方申请</van-radio>
          </van-radio-group>
        </div>
        <div class="reason">
          <van-radio-group v-if="!allElectric" v-model="redReason">
            <!-- 税控 -->
            <van-radio icon-size="18" name="1">销售退回</van-radio>
            <van-radio icon-size="18" name="2">开票有误</van-radio>
            <van-radio icon-size="18" name="3">服务中止</van-radio>
            <van-radio icon-size="18" name="4">销售折让</van-radio>
          </van-radio-group>
          <van-radio-group v-else v-model="redReason">
            <!-- 税控 -->
            <van-radio icon-size="18" name="1">销售退回</van-radio>
            <van-radio icon-size="18" name="2">开票有误</van-radio>
            <van-radio icon-size="18" name="3">服务中止</van-radio>
            <van-radio icon-size="18" name="4">销售折让</van-radio>
          </van-radio-group>
        </div>
      </div>
    </main>
    <footer>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('return')"
        >
          <span>返回</span>
        </MainButton>
      </div>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('confirm')"
        >
          <span>确认红字发票信息</span>
        </MainButton>
      </div>
    </footer>
  </div>
</template>

<script>
import { Field, RadioGroup, Radio } from 'vant'
import MainButton from '@/components/MainButton/index.vue'
import ModuleHeadText from '@/components/ModuleHeadText/index.vue'
import { mapMutations, mapState } from 'vuex'
import { isUniversalTicket, isAllElectric } from '@utils/basicUtil'
export default {
  components: {
    ModuleHeadText,
    MainButton,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field
  },
  computed: {
    ...mapState('invoiceRedModel', ['invoiceInfo']),
    getInvoiceType () {
      return isUniversalTicket(this.invoiceInfo.invoiceType)
    },
    allElectric () {
      return isAllElectric(this.invoiceInfo.invoiceType)
    }
  },
  data () {
    return {
      name: 1,
      applicationType: '1',
      redReason: '1'
    }
  },
  mounted () {

  },
  methods: {
    ...mapMutations('invoiceRedModel', ['setApplicationType', 'setRedReason']),
    handleBtnClick (type) {
      if (type === 'confirm') {
        this.setApplicationType(this.applicationType)
        this.setRedReason(this.redReason)
        this.$router.push('/invoice-red/confirm')
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="less" scoped src="./style.less" />
